// Every user-controlled string reaches the DOM through here. Quotes are escaped
// as well as angle brackets because esc() output is interpolated into ATTRIBUTE
// values too (aria-label, title) — a record key or path containing `"` would
// otherwise break out of the attribute and inject arbitrary markup attributes
// (REL-053). Single quotes are covered for attribute styles that use them.
export const esc = (s) =>
  String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
